import { TextKey, DataTestId } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { LocalizedMinorHighlight, LocalizedSmallParagraph } from '@mews-commander/ui';
import { uberImage as uberImagePath } from '@mews-commander/assets';
import { MewsImage } from '@mews/business-components';
import { Button } from '@optimus-web/core';
import { Widget } from '@mews-commander/dashboard/widgets';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { searchMarketplace } from '../actions';

const imageHeight = '72px';
const UBER_SEARCH_TERM = 'Uber For Hotels';

export const UberWidget = () => {
    const dispatch = useCommanderThunkDispatch();

    const handleClick = () => {
        dispatch(searchMarketplace(UBER_SEARCH_TERM));
    };

    return (
        <Widget titleTextKey={TextKey.Marketplace}>
            <MewsImage
                src={uberImagePath}
                height={imageHeight}
                objectFit="contain"
                objectPosition="left top"
                shouldShowLoader
            />
            <LocalizedMinorHighlight textKey={TextKey.DashboardWidgetUberHeaderText} />
            <LocalizedSmallParagraph textKey={TextKey.DashboardWidgetUberText} />
            <div>
                <Button onClick={handleClick} data-test-id={DataTestId.DashboardWidgetUberButton} type="submit">
                    <LocalizedText textKey={TextKey.DiscoverMore} />
                </Button>
            </div>
        </Widget>
    );
};
